<template lang="html">
  <div class="CRUDGenerico__Wrapper" v-if="canAccessPage">
    <v-card class="card-size">
      <v-card-title>
        <h3 class="headline mb-0">{{ $tc('title.parametrizacao_orcamento', 1) }}</h3>
      </v-card-title>
      <v-row justify="start">
        <v-col cols="12" sm="6" md="3" class="ml-3">
          <v-text-field
            id="param_orc_pesquisar"
            v-model="search"
            @input="filtrar"
            append-icon="search"
            :label="$t('label.pesquisar')"
            single-line
            clearable
            hide-details>
          </v-text-field>
        </v-col>
      </v-row>
      <v-data-table
        id="param_orc_grid"
        :headers="headers"
        :items="lista"
        hide-default-footer
        disable-pagination
        :items-per-page="-1"
        :no-data-text="$t('label.tabela_sem_conteudo')">
        <template v-slot:item.acoes="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon class="mx-0" v-on="on" @click="editItem(item)">
                <v-icon>edit</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('label.editar') }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <v-card-actions>
      <v-row>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn fab
              bottom right fixed
              class="v-btn__fab"
              color="primary"
              v-on="on"
              @click.native="openNewForm">
              <v-icon id="param_orc_add">add</v-icon>
            </v-btn>
          </template>
          <span>{{$t('label.novo_tipo')}}</span>
        </v-tooltip>
      </v-row>
    </v-card-actions>
  </div>
</template>

<script type="text/javascript">
import { generateComputed } from '../../../common/functions/roles-computed-generator';

export default {
  name: 'ParametrizacaoOrcamento',
  data() {
    return {
      resources: this.$api.parametrizacaoOrcamento(this.$resource),
      esperar: false,
      search: '',
      headers: [
        {
          text: '', value: 'acoes', width: '2%', sortable: false,
        },
        { text: this.$tc('label.nome', 1), value: 'nome' },
        { text: this.$tc('label.descricao', 1), value: 'descricao' },
        { text: this.$tc('label.forma_rateio', 1), value: 'forma_rateio' },
      ],
      lista: [],
    };
  },
  components: {

  },
  computed: {
    ...generateComputed('Param Orc', [
      'canAccessPage',
    ]),
  },
  methods: {
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast('Acesso negado');
      }
    },
    filtrar() {
      if (this.esperar) return;
      this.esperar = true;
      setTimeout(() => {
        this.buscar();
      }, 5E2);
    },
    editItem(item) {
      this.$router.push({ name: 'editarParametrizacaoOrcamento', params: { id: item.id } });
    },
    buscar() {
      const params = {
        filtro: this.search,
      };

      this.resources.buscar(params).then((response) => {
        this.lista = response.data;
        this.pararEsperar();
      }, (err) => {
        this.pararEsperar();
        this.$error(this, err);
      });
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
      }, 2E2);
    },
    openNewForm() {
      this.$router.push({ name: 'novoParametrizacaoOrcamento' });
    },
  },
  mounted() {
    this.filtrar();
  },
  beforeMount() {
    if (!this.canAccessPage) {
      window.setTimeout(() => {
        this.accessForbidden();
      }, 1E3);
    }
  },
};
</script>
